import logo200Image from '../assets/img/logo/logo_2.png'
import React from 'react'
import { Button, Form, FormGroup, Input, Label, Row, Col, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Typography from '../components/Typography'
import axios from '../utils/posAxios'
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md'
import Avatar from '../components/Avatar'
import userPlaceholder from '../assets/img/users/profile.jpg'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { getPayment } from '../utils/dropdownlist'

class PosCategoryForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      category_id: '',
      name: '',
      store_id: '0',
    }
  }

  componentDidMount() {
    if (this.props.data.isEdit) {
      let id = this.props.data.selectedId
      const data = this.props.data.categoryList.find(e => e.id === id)
      this.setState({
        isEdit: true,
        category_id: id,
        name: data.name,
        store_id: data.store_id,
      })
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    if (!this.state.isEdit) {
      this.createCategory(user, comp, url)
    } else {
      this.editCategory(user, comp, url)
    }
  }

  createCategory(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      name: this.state.name,
      store_id: this.state.store_id,
      created_by: user.email,
    }

    axios
      .post(url + ':3002/v2/product/category/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New category added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  editCategory(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      category_id: this.state.category_id,
      store_id: this.state.store_id,
      name: this.state.name,
      update_by: user.email,
    }

    axios
      .post(url + ':3002/v2/product/category/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Category updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Category</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Name</Label>
                <Input type="text" name="name" value={this.state.name} onChange={this.changeHandler} required />
              </FormGroup>
              <FormGroup>
                <Label>Store</Label>
                <Input type="select" name="store_id" value={this.state.store_id} onChange={this.changeHandler} required>
                  <option value="0">Global</option>
                  {this.props.data.storeList &&
                    this.props.data.storeList.length > 0 &&
                    this.props.data.storeList.map((item, index) => {
                      return (
                        <option key={index} value={item.store_id}>
                          {item.name}
                        </option>
                      )
                    })}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export const STATE_ADD = 'ADD'
export const STATE_EDIT = 'EDIT'
export default PosCategoryForm
